import axios from 'axios';
import api from './apiConfig';
import { Breed } from '../types/breed';

export const getBreeds = async (akcGroup?: string): Promise<Breed[]> => {
  try {
    const params = akcGroup ? { akc_group: akcGroup } : {};
    const response = await api.get<{ breeds: Breed[] }>('/api/breeds', { params });
    return response.data.breeds;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || 'Failed to fetch breeds');
    }
    throw new Error('Network error when trying to fetch breeds');
  }
};

export const getBreed = async (breedId: number): Promise<Breed> => {
  try {
    const response = await api.get<Breed>(`/api/breeds/${breedId}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || 'Failed to fetch breed');
    }
    throw new Error('Network error when trying to fetch breed');
  }
};

export const getAkcGroups = async (): Promise<{ group_name: string; breed_count: number }[]> => {
  try {
    const response = await api.get<{ group_name: string; breed_count: number }[]>('/api/breeds/akc-groups');
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || 'Failed to fetch AKC groups');
    }
    throw new Error('Network error when trying to fetch AKC groups');
  }
};